import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useClientApi } from '../features/api/use-client-api';
import showErrorNotification from '../features/utils/show-error-notifications';

const BillingRedirect = () => {
  const api = useClientApi();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const session = await api.fetchBillingSession(
          window?.location?.origin || '',
        );
        window.location.href = session.url;
      } catch (err: any) {
        showErrorNotification(err.response.data.error_code);
        navigate('/');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default BillingRedirect;
